/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import Router from 'next/router';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: 100vh;
  background: #0b0e11;
  cursor: pointer;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
`;

const CoinBox = styled(FlexBox)`
  height: 100%;
  align-items: center;
`;
const CoinLeft = styled.div`
  width: 580px;
  padding: 0 0 0 46px;
  color: #fff;
  text-align: left;
  @keyframes fadeIn {
    0% {
      display: none;
      opacity: 0;
    }
    to {
      display: block;
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
      display: block;
      opacity: 1;
    }
    to {
      display: none;
      opacity: 0;
    }
  }
  &.fadeIn {
    animation: fadeIn 3s;
  }
  &.fadeOut {
    animation: fadeOut 3s;
  }
  > h3 {
    font-size: 54px;
    font-weight: 300;
    line-height: 70px;
    padding: 0 0 26px 0;
    margin: 0;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  > p {
    padding: 0;
    margin: 0 0 30px 0;
    font-size: 20px;
    line-height: 28px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    color: rgba(255, 255, 255, 0.6);
  }
  > a {
    font-size: 18px;
    font-weight: 500;
    color: rgba(240, 185, 11, 1);
    line-height: 32px;
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;
const CoinRight = styled.div`
  padding-left: 50px;
  width: 680px;
  text-align: right;
  img {
    width: 380px;
    opacity: 0.6;
    margin-right: 100px;
  }
`;

const CurrentBox = styled.div`
  padding: 170px 0 0 0;
  > h3 {
    font-size: 20px;
    line-height: 28px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    margin: 0;
    padding: 0 0 15px 0;
    position: relative;
    cursor: pointer;
    float: left;
    & a{
      font-size: 20px;
      line-height: 28px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
      color: inherit !important;
    }
    > span {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background: #646669;
      width: 50px;
    }
    &:first-child {
      > span {
        ${({ isFirst }) => (isFirst ? (`display:none;`) : `display:block;`)};
      }
    }
    &:last-child {
      margin-left: 60px;
      > span {
        ${({ isFirst }) => (isFirst ? (`display:block;`) : `display:none;`)};
      }
    }
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

type States = {
  isScroll: boolean,
  isFirst: boolean,
};

export default
@withI18n
class BinanceCoin extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  state = {
    isScroll: false,
    isFirst: false,
  };

  // componentDidMount() {
  //   window.addEventListener('scroll', this._handleScroll);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('scroll', this._handleScroll);
  // }

  _handleScroll = () => {
    const scrollTop = document.getElementById('scroll').offsetTop;
    const winScrollTop =
      document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    if (winScrollTop - scrollTop >= 150) {
      this.setState({ isScroll: true });
    } else {
      this.setState({ isScroll: false });
    }
  };

  _setShow = (e: MouseEvent, num: number) => {
    e.stopPropagation();
    if (num === 1) this.setState({ isFirst: true });
    if (num === 2) this.setState({ isFirst: false });
  };

  _renderCurrent = () => {
    const { i18n } = this.props;
    const { isFirst } = this.state;
    return (
      <CurrentBox isFirst={ isFirst }>
          <h3 onClick={(e) => this._setShow(e,2)}>
            <a id="binanceCoin-a-useTradeStore">{getLabel('exchange-binanceCoin-useTradeStore', i18n)}</a> <span />
          </h3>
          <h3 onClick={(e) => this._setShow(e,1)}>
            <a id="binanceCoin-a-binanceCoin">{getLabel('exchange-binanceCoin-binanceCoin', i18n)}</a> <span />
          </h3>
      </CurrentBox>
    );
  };

  _handleClick = () => {
    Router.push(`/${this.props.locale}/bnb`)
  }

  render() {
    const { i18n } = this.props;
    const { isScroll, isFirst } = this.state;
    return (
      <WrapperBox direction="column" id="scroll" onClick={this._handleClick} >
        <Content>
          <CoinBox direction="row">
            {
              isFirst && (
              <CoinLeft className={isFirst ? 'fadeIn' : 'fadeOut'}>
                <h3>{getLabel('exchange-binanceCoin-binanceCoin', i18n)}</h3>
                <p>{getLabel('exchange-binanceCoin-binanceCoinIntroduction', i18n)}</p>
                <a id="binanceCoin-a-binanceCoinLearnMore" href="bnb" target="_blank" rel="noopener noreferrer nofollow">
                  {getLabel('exchange-common-learnMore', i18n)} {'>>'}
                </a>
                {this._renderCurrent()}
              </CoinLeft>
            )
            }
            {
              !isFirst && (
              <CoinLeft className={!isFirst ? 'fadeIn' : 'fadeOut'}>
                <h3>{getLabel('exchange-binanceCoin-useTradeStore', i18n)}</h3>
                <p>{getLabel('exchange-binanceCoin-useTradeStoreIntroduction', i18n)}</p>
                <a  id="binanceCoin-a-useTradeStoreLearnMore" href="bnb" target="_blank" rel="noopener noreferrer nofollow">
                  {getLabel('exchange-common-learnMore', i18n)} {'>>'}
                </a>
                {this._renderCurrent()}
              </CoinLeft>
            )
            }
            <CoinRight>
              <img src={require('./imgs/Coin-Rendering.png')} alt="Use.Adoption.Store" />
            </CoinRight>
          </CoinBox>
        </Content>
      </WrapperBox>
    );
  }
}
